import React, { useState, useEffect, useReducer } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formReducer, INITIAL_STATE } from './reducer/formReducer';
import { updateFormFields, updateFormField } from './actions/actions';
import Loader from "./components/loader";
import CopyURL from "./components/copyUrl";
import PasswordInput from "./components/passwordInput";
import URLBASE from "../api/urlRegister";
import { checaFormatoSenha } from "./util/utils";
import logoutSession from './crud/logout';
import '../App.css';

import Template02 from './images/template-02.jpeg';

const CadastroEcommerce = () => {
	
	// TO DO: o código será refatorado e padronizado para inglês em breve ...
	
	const navigate = useNavigate();
	
	const notificationError = message => toast.error(message);
	const notificationSuccess = message => toast.success(message);
	
	const [usuario, dispatch] = useReducer(formReducer, INITIAL_STATE);
	
	const [logado, setLogado] = useState(false);
	const [loadingFullPage, setLoadingFullPage] = useState(false);
	// TO DO: remover esses loadings, os hooks que serão feitos fornecerão os próprios loadings
	const [loadingDelete, setLoadingDelete] = useState(false); 
	const [loadingUpdate, setLoadingUpdate] = useState(false);
	
	const token = sessionStorage.getItem("tkn");
	const id = sessionStorage.getItem("idl");
	
	useEffect(() => {
		const checkTokenAndId = id?.length && token?.length;
		if (checkTokenAndId) {
			async function getUser(){
				try{
					
					setLoadingFullPage(true)
					
					let urlGet = URLBASE + "/loja/" + id;
					const headerConfig = {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json',
					  'Authorization': 'Bearer ' + token,
					  'Access-Control-Allow-Origin': 'GET',
					}
					const response = await fetch(urlGet, {
						method: 'GET',
						headers: headerConfig,
					  });
					const content = await response.json();
					
					if(response.status === 200){															
						updateFormFields(content, dispatch);					
						setLogado(true);
					}else{
						navigate("/");
					}
					
				}catch(error){
					notificationError(error.message);
				}finally{
					setTimeout(() => {
					  setLoadingFullPage(false);
					}, '2000')
				}
			}
			
			getUser();
				
		}
				
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	
	// REQUISIÇÕES - TO DO: mover essa parte pra uma pasta
	async function postEcommerceForm(e){
		e.preventDefault();
		const inputsValidos = checaInputs();
		if(inputsValidos){		
			let urlPost = URLBASE + "/cadastrar"
			try{
				let headerConfig = {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json'
					}
				if(logado){
					headerConfig = {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json',
					  'Authorization': 'Bearer ' + token
					}
				}
				setLoadingUpdate(true);
				const response = await fetch(urlPost, {
					method: 'POST',
					headers: headerConfig,
					body: JSON.stringify({
						usuario: usuario.usuario,
						nome: usuario.nomeLoja,
						email: usuario.email,
						cor: usuario.cor,
						template: usuario.template,
						textoPedidoACaminho: usuario.textoPedidoACaminho,
						textoPedidoEntregue: usuario.textoPedidoEntregue,
						senha: usuario.senha,
						url: usuario.url,
						logotipo: usuario.logotipo,
						apoiador: usuario.apoiador,
						logado: logado
					})
				  });
				  const content = await response.json();
				  if(response.status === 200) {
					  notificationSuccess(content.mensagem);				  
				  }else{
					  notificationError(content.mensagem);
				  }
				  
			}catch(error){
				notificationError('Não foi possível cadastrar');
			}finally{
				setLoadingUpdate(false)
			}
		}else{
			notificationError('Formulário incorreto.');
		}
	}
	
	async function deleteEcommerceForm(){ 
		if(id !== "" && id != null){		
			let urlDelete = URLBASE + "/deletar/" + id
			try{
				let headerConfig = {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json'
					}
				if(logado){
					headerConfig = {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json',
					  'Authorization': 'Bearer ' + token,
					  'Access-Control-Allow-Origin': 'DELETE',
					}
				}
				setLoadingDelete(true);
				const response = await fetch(urlDelete, {
					method: 'DELETE',
					headers: headerConfig,
				  });

				  if(response.status === 200) notificationSuccess('Cadastro deletado.');
				  
				  sessionStorage.setItem("tkn", "");
				  sessionStorage.setItem("idl", "");
				  setTimeout(() => {
					  navigate("/")
					}, '500')
			}catch(error){
				notificationError(error.message);
			}finally{
				setLoadingDelete(false)
			}
		}else{
			notificationError('Não foi possível deletar o cadastro da sua loja.');
		}
	}
	
	// REQUISIÇÕES - TO DO: mover essa parte pra uma pasta
	
	
	function onChangeLogo(e) {
		
		let checaExtensao = e.target.files[0] && (e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/jpg");
		let checaTamanho = e.target.files[0] && (e.target.files[0].size < 20000);
		
		if( checaExtensao && checaTamanho ){
			const reader = new FileReader()
			reader.addEventListener("load", () => {
				//quando a imagem for lida
				let image = new Image();
				image.src = reader.result;
				image.onload = function () {
					//testa se a imagem tem a dimensão correta(largura e altura de 230px)
					if(image.width === 230 && image.height === 230){
						updateFormField('logotipo', reader.result, dispatch);
					}else{
						//tira a imagem da value do input file
						document.getElementById("logotipo").value = "";
						notificationError('Imagem inválida selecionada.');
					}
				}				
			})
			reader.readAsDataURL(e.target.files[0])
		}else{
			document.getElementById("logotipo").value = "";
			notificationError('Imagem inválida selecionada.');
		}
	}
	
	function checaInputs(){
		const senha = logado && !usuario.senha?.length ? true : checaFormatoSenha(usuario.senha);
		return(
			senha && 
			usuario.logotipo && 
			usuario.url && 
			usuario.nomeLoja && 
			usuario.usuario && 
			usuario.textoPedidoEntregue 
			&& usuario.textoPedidoACaminho 
			&& usuario.template && 
			usuario.cor);
	}
	
	function deleteAccount(){
		if( window.confirm("Deseja realmente excluir o cadastro da sua loja?") ) deleteEcommerceForm();
	}
	
	const handlePassword = e => {
		updateFormField(e.target.name, e.target.value, dispatch);
	}

	function clearState(){
		
		logoutSession(token, id, URLBASE);
		updateFormFields(INITIAL_STATE, dispatch);
		setLogado(false);
		setLoadingDelete(false);
		setLoadingUpdate(false);
		sessionStorage.setItem('tkn', '');
		sessionStorage.setItem('idl', '');
		
		navigate('/');
		
	}
		
	
	const urlPaginaLoja = logado && "https://www.minhaencomenda.me/rastreio/" + id + "/" + usuario.nomeLojaFormatado + "/codigo-de-rastreio";
	const cadastrarLojaBtnText = logado ? "Atualizar cadastro" : "Cadastrar loja";

	// TO DO: refatorar também todo o conteúdo do return abaixo
	return(
			<>	
				
					<div className="row">
					
						<div className="col-sm coluna-lateral"></div>
						
						<div className="col-lg-10 custom-col">
						{loadingFullPage && <div id="loader-full-screen"><div id="loader"><h5>Por favor, aguarde ...</h5></div></div>}
																					
						<div id="cadastro-loja" className="card shadow-sm rounded">

							<h4>Integração para E-commerce <a href="https://www.minhaencomenda.me/">Minha Encomenda</a> | {logado ? usuario.nomeLoja : "Cadastrar loja"}</h4>
							
							
							<br/>

							<p>
								{logado ? `
								Olá, ${usuario.usuario.split(" ")[0]}! Essas são as informações da sua loja cadastrada. 
									Nessa página você pode atualizar ou deletar o cadastro da sua loja. 
									Coloque o código de rastreio da encomenda no final da url quando for compartilhar com o seu cliente. 									
									Rastreio disponível para Correios e Jadlog.
								` : `
								Preencha o formulário abaixo para cadastrar a sua loja virtual e habilitar a sua página de rastreamento personalizada (disponível para Correios e Jadlog). Após
									cadastrar sua loja, faça o login para ter acesso à url da sua página. Coloque o código de rastreio da encomenda no final da url quando for compartilhar com o seu cliente.													
								`}				
							</p>
							{ logado && 
								<>
								  <div id="apoiar" style={{marginBottom: "15px"}}>
								  
									<h6><b>Seja um apoiador</b></h6>
									<p>Você pode doar qualquer quantia
									e com isso colaborar com a manutenção desse serviço! Basta clicar no botão "Doar"
									abaixo, você será redirecionado para a nossa página de doação do Paypal. 😊
									</p>
									<form action="https://www.paypal.com/donate" method="post" target="_top">
									<input type="hidden" name="business" value="GCA64U997YHE8" />
									<input type="hidden" name="no_recurring" value="0" />
									<input type="hidden" name="item_name" value=" " />
									<input type="hidden" name="currency_code" value="BRL" />
									<input type="image" src="https://www.paypalobjects.com/pt_BR/BR/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Faça doações com o botão do PayPal" />
									<img alt="" border="0" src="https://www.paypal.com/pt_BR/i/scr/pixel.gif" width="1" height="1" />
									</form>

								  </div>
								</>
							  }
							
							{logado && <><br/><span>URL da sua página</span>
								<CopyURL url={urlPaginaLoja.split("codigo-de-rastreio")[0]} />
								<small className="mt-2"><b>Dica: </b>acesse o site parceiro <a href="https://www.gera-link.com/encurtador" target="_blank" rel="noreferrer">Gera-Link</a> para encurtar a URL.</small>
							</>}
							
							<br/>
							
							<h6 style={{marginTop: 23}}><b>Templates disponíveis</b> </h6><br/>
							<div id="escolher-template" style={{display: "flex", flexWrap: "wrap", justifyContent: "start", marginBottom: "20px"}}>								
										<div style={{marginBottom: "10px", marginTop: "10px"}}>									
											<div><a href={require("./images/demonstracao.png")} target="_blank" rel="noreferrer"><img src={Template02} className="img-fluid border-img-template" aria-hidden="true" alt="imagem de demonstração da página customizada" /></a></div>
											<div style={{marginTop: "5px"}}>
												<center>
													<input className="form-check-input" type="radio" name="template" id="temp1" value="1" checked={usuario.template === "1"} onChange={(e) => {}} />
													<label className="form-check-label" htmlFor="temp1">
														Padrão
													</label>
												</center>
											</div>
										</div>							
							</div>
									
								
							<form onSubmit={postEcommerceForm}>
							  
							  <label htmlFor="usuario">Seu nome</label>
							  <input id="usuario" type="text" required name="usuario" className="form-control shadow-none" value={usuario.usuario} onChange={(e) => updateFormField(e.target.name, e.target.value, dispatch)}/><br/>
							
							  <label htmlFor="nome">Nome da sua loja</label>
							  <input id="nome" type="text" required name="nomeLoja" className="form-control shadow-none" value={usuario.nomeLoja} onChange={(e) => updateFormField(e.target.name, e.target.value, dispatch)}/><br/>
							  
							  <label htmlFor="url">URL da sua loja (site ou rede social)</label>
							  <input id="url" type="url" required name="url" className="form-control shadow-none" value={usuario.url} onChange={(e) => updateFormField(e.target.name, e.target.value, dispatch)}/><br/>
							  
							  <label htmlFor="pedido-a-caminho">Texto para quando o pedido for enviado. Ex: Pedido enviado! Agradecemos a preferência.</label>
							  <input id="pedido-a-caminho" type="text" required name="textoPedidoACaminho" className="form-control shadow-none" value={usuario.textoPedidoACaminho} onChange={(e) => e.target.value.length < 46 && updateFormField(e.target.name, e.target.value, dispatch)}/><br/>
							  
							  <label htmlFor="pedido-entregue">Texto para quando o pedido for entregue. Ex: Obrigado por comprar conosco 🧡</label>
							  <input id="pedido-entregue" type="text" required name="textoPedidoEntregue" className="form-control shadow-none" value={usuario.textoPedidoEntregue} onChange={(e) => e.target.value.length < 46 && updateFormField(e.target.name, e.target.value, dispatch)}/><br/>
							  

							  <label htmlFor="email">Seu e-mail de contato</label>
							  <input id="email" type="email" required name="email" className="form-control shadow-none" defaultValue={usuario.email} onChange={(e) => updateFormField(e.target.name, e.target.value, dispatch)} disabled={logado} /><br/>
							  
							  <label htmlFor="password">{logado ? "Senha" : "Crie uma senha"}</label>
							  <PasswordInput senha={usuario.senha} onChangeFunc={handlePassword} titleTooltip="clique para mostrar ou esconder a senha" tooltipPosition="top" checkPassword={true} />
						  
							  <br/>
							  							  
							  <div id="upload-imagem" className="form-group">
								<label htmlFor="logotipo">{logado ? `Você possui uma imagem cadastrada. Clique no botão abaixo se desejar selecionar outra imagem para sua loja (formato jpg ou jpeg, dimensão de 230x230 e menos de 20KB)` : "Imagem da sua loja (formato jpg ou jpeg, dimensão de 230x230 e menos de 20KB)"}</label>
								<input id="logotipo" name="logotipo" required={!logado} type="file" accept="image/jpeg" className="form-control-file shadow-none" onChange={onChangeLogo} />								
							  </div>
							  
							  <div id="escolher-cor" className="form-group">							
								<label htmlFor="cor">{logado ? "Cor do template" : "Selecione uma cor para ser utilizada em conjunto com a imagem"}</label><br/>
								<input type="color" id="cor" name="cor" required value={usuario.cor} onChange={(e) => updateFormField(e.target.name, e.target.value, dispatch)} />							
								<div id="previa" className="rounded" style={{backgroundColor: usuario.cor}}>
									<center><img id="logo-previa" className="rounded-circle" src={usuario.logotipo} alt="logotipo" /></center>
								</div>								
							  </div>
							  
							  <br/>								
							  
							  <button id="btn-cadastro-loja" className="btn shadow-none">{loadingUpdate ? <Loader small={true} color={"#ffffff"} /> : cadastrarLojaBtnText}</button>
							  
							  </form>
							  
							  { logado && <button id="btn-deletar-loja" className="btn shadow-none" onClick={() => deleteAccount()}>{loadingDelete ? <Loader small={true} color={"#ffffff"} /> : 'Deletar cadastro da loja'}</button> }							  
														  
							
							<footer>{ logado ? <button type="button" className="btn btn-light btn-sm btn-exit" onClick={(e) => clearState()}>
								
								<div style={{marginRight: 5}}>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-left" viewBox="0 0 16 16">
									  <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/>
									  <path fillRule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>
									</svg>
								</div>
								<div style={{marginTop: 3}}>
									Encerrar minha sessão
								</div>
							
							</button> : <small><Link to="/">Voltar</Link></small>}</footer>
							
						</div>
						<br/><br/><br/><br/>

						</div>
						
						<div className="col-sm coluna-lateral"></div>
					</div>
										
				
			</>

	)
}
	

export default CadastroEcommerce;
